import { render, staticRenderFns } from "./InvoicePaymentsDashboard.yaml?vue&type=template&id=1663da99&component"
import script from "./InvoicePaymentsDashboard.yaml?vue&type=script&lang=ts&component"
export * from "./InvoicePaymentsDashboard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports